import {
  format as formatPhone,
  AsYouType,
  parse as phoneParse,
  isValidNumber as isValidPhone
} from 'libphonenumber-js';

export const isValidPhoneNumber = (phoneNumber, countryCode, settings) => {
  if (!countryCode) {
    return isValidPhone(phoneNumber, settings.data.countryCode);
  }
  return isValidPhone(phoneNumber, countryCode);
};

export const phoneNormalize = (value, prevValue, allValues) => {
  let phoneNumber = integerOnly(value);
  const country = allValues.countryCode;
  const prevPhoneNumber = integerOnly(prevValue);
  if (
    phoneNumber &&
    prevPhoneNumber &&
    phoneNumber === prevPhoneNumber &&
    value.length < prevValue.length
  ) {
    phoneNumber = phoneNumber.slice(0, -1);
  }
  return phoneNumber && new AsYouType(country).input(phoneNumber);
};

export const phoneFormat = (phone, countryCode) => {
  if (!phone) {
    return null;
  }
  return formatPhone(phoneParse(phone, countryCode), 'National') || phone;
};

export const phoneFormatForDB = (phone, countryCode) => {
  if (!phone) {
    return null;
  }
  const country = countryCode;
  if (isValidPhoneNumber(phone, country)) {
    return formatPhone(phoneParse(phone, country), 'E.164');
  }
  return integerOnly(phone);
};

const integerOnly = (value) => {
  if (value) {
    return value.replace(/[^\d]/g, '');
  }
  return value;
};
